import React from 'react';
import autoBind from 'react-autobind';
import { Redirect } from 'react-router-dom';
import noty from '../../lib/noty';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider';
import FieldCheck from '../FieldCheck';
import { Subscribe, appContainer } from '../../contexts/app';
import colors from '../../themes/colors';

class TrainingModal extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      fetching: false,
      redirect: null,
      currentUser: this.props.currentUser,
      touched: false,
      activeTutorial: this.props.trainingTutorials.toList().toJS()[0]
    };
  }

  handleChange({ id }) {
    const { currentUser } = this.state;
    const index = currentUser.trainingTutorials.findIndex(tut => tut === id);
    // If the ID does not exist in the users trainingTutorials, add it.
    if (index === -1) {
      this.setState({
        touched: true,
        currentUser: currentUser.setIn(
          ['trainingTutorials', currentUser.trainingTutorials.length],
          id
        )
      });
    } else {
      const updatedTutorialIds = currentUser.trainingTutorials.filter(
        _id => _id !== id
      );
      this.setState({
        touched: true,
        currentUser: currentUser.setIn(
          ['trainingTutorials'],
          updatedTutorialIds
        )
      });
    }
  }

  handleVideoChange(tutorial) {
    this.setState({ activeTutorial: tutorial });
  }

  handleClose(event) {
    if (this.state.touched) {
      event.preventDefault();
      const { currentUser } = this.state;
      this.setState({ fetching: true });
      currentUser
        .patch()
        .then(patchedUser => {
          this.setState({
            fetching: false,
            touched: false
          });
          noty.success('Tutorials updated.');
        })
        .catch(err => {
          this.setState({ fetching: false });
          noty.errors(err);
        });
    }
    this.props.onRequestClose();
  }

  render() {
    const { fetching, currentUser, activeTutorial } = this.state;
    const { trainingTutorials } = this.props;
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const actions = [
      <FlatButton
        label="Done"
        primary
        onClick={this.handleClose}
        disabled={fetching}
      />
    ];

    return (
      <Dialog
        autoScrollBodyContent
        actions={actions}
        open={this.props.trainingModalOpen}
        contentStyle={{ maxWidth: 1200 }}
      >
        <div style={{ padding: 16 }}>
          <div>
            <div style={{ marginBottom: 32 }}>
              <h2>
                Welcome to <span style={{ color: colors.blue }}>MapPlug</span>!
                Let's learn how to use it...
              </h2>
              <p style={{ paddingTop: 16, paddingBottom: 16 }}>
                To be proficient with the system, you should master a few basic
                tasks. Watch a video about each task, try it at your own
                facility, and then check it off here.
              </p>
            </div>
            <div className="row">
              <div className="col-md-6">
                {trainingTutorials
                  .toList()
                  .toJS()
                  .map(tutorial => {
                    return (
                      <div style={{ paddingBottom: 16 }} key={tutorial._id}>
                        <div className="row" style={{ paddingBottom: 16 }}>
                          <div className="col-md-8">
                            <FieldCheck
                              label={tutorial.description}
                              name={tutorial._id}
                              onChange={({ name }) => {
                                this.handleChange({
                                  id: name
                                });
                              }}
                              checked={currentUser.trainingTutorials.includes(
                                tutorial._id
                              )}
                              disabled={fetching}
                            />
                          </div>
                          <div className="col-md-4">
                            <FlatButton
                              onClick={() => this.handleVideoChange(tutorial)}
                              label="Watch Video"
                              primary
                              disabled={activeTutorial.link === tutorial.link}
                            />
                          </div>
                        </div>
                        <Divider />
                      </div>
                    );
                  })}
              </div>
              <div
                className="col-md-6"
                style={{
                  display: 'inline-block'
                }}
              >
                <div>
                  <span>{activeTutorial.description}</span>
                  {/*
                    TODO: when a user pauses a video, keep the video paused time in state so they can resume where they left off (while working through a tutorial, for example). This would require a more robust video component
                  */}
                  <iframe
                    title="videoPlayer"
                    src={activeTutorial.link}
                    width="500"
                    height="300"
                    frameBorder="0"
                    allowFullScreen
                  />
                  {activeTutorial.zendeskLink && (
                    <p style={{ textAlign: 'center' }}>
                      <a href={activeTutorial.zendeskLink} target="_blank">
                        Watch this video in a new tab with step-by-step
                        instructions
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <p style={{ marginTop: 32 }}>
            Choose "Training" from the drop down menu to return to this screen
            any time
          </p>
        </div>
      </Dialog>
    );
  }
}

export default routerProps => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return (
          <TrainingModal
            {...routerProps}
            currentUser={app.state.get('currentUser')}
            trainingTutorials={app.state.get('trainingTutorials')}
            trainingModalOpen={app.state.get('trainingModalOpen')}
          />
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/TrainingModal/index.jsx